import { useTranslation } from 'react-i18next';
import { Toggle } from '../UI/base';
import { WeeklyScheduleEditor } from './WeeklyScheduleEditor';
import type {
  AvailabilityForm,
  DayKey,
  WeekParity,
  WeekScheduleForm
} from './staffScheduleConstants';
import styles from './StaffAvailabilityEditor.module.css';

interface StaffAvailabilityEditorProps {
  value: AvailabilityForm;
  dayErrors: Record<WeekParity, Partial<Record<DayKey, string>>>;
  onChange: (next: AvailabilityForm) => void;
}

export const StaffAvailabilityEditor = ({
  value,
  dayErrors,
  onChange
}: StaffAvailabilityEditorProps) => {
  const { t } = useTranslation();

  const updateWeek = (week: WeekParity, schedule: WeekScheduleForm): void => {
    onChange({ ...value, [week]: schedule });
  };

  return (
    <div className={styles.editor}>
      <label className={styles.alternatingToggle}>
        <Toggle
          checked={value.isAlternating}
          onChange={(checked) => onChange({ ...value, isAlternating: checked })}
        />
        <span>{t('config-staff-alternating-weeks')}</span>
      </label>

      {value.isAlternating ? (
        <>
          <div className={styles.weekSection}>
            <span className={styles.weekLabel}>{t('config-staff-even-weeks')}</span>
            <WeeklyScheduleEditor
              value={value.evenWeeks}
              dayErrors={dayErrors.evenWeeks}
              onChange={(schedule) => updateWeek('evenWeeks', schedule)}
            />
          </div>
          <div className={styles.weekSection}>
            <span className={styles.weekLabel}>{t('config-staff-odd-weeks')}</span>
            <WeeklyScheduleEditor
              value={value.oddWeeks}
              dayErrors={dayErrors.oddWeeks}
              onChange={(schedule) => updateWeek('oddWeeks', schedule)}
            />
          </div>
        </>
      ) : (
        <WeeklyScheduleEditor
          value={value.evenWeeks}
          dayErrors={dayErrors.evenWeeks}
          onChange={(schedule) => updateWeek('evenWeeks', schedule)}
        />
      )}
    </div>
  );
};
